import React from 'react'
import { connect } from 'react-redux'
import { changeProjectFromStartupAction } from 'actions/projectActions'
import compose from 'ramda/src/compose'
import injectSheet from 'react-jss'
import style from 'components/ProjectList/style'
import timeAgo from 'helpers/timeAgo'
import Fuse from 'fuse.js'

function mapStateToProps({ projects }) {
  return { projects }
}

class StartupProjectList extends React.Component {
  state = { filter: '' }

  constructor(props) {
    super(props)
    const options = {
      threshold: 0.3,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      shouldSort: false,
      includeScore: false,
      isCaseSensitive: false,
      keys: ['title']
    }
    this.fuse = new Fuse(this.props.projects, options)
  }

  updateFilter = ({ target: { value } }) => {
    this.setState({ filter: value })
  }

  filterProjects = projects => {
    const { state: { filter } } = this
    if (filter === '') return projects
    return this.fuse.search(filter)
  }

  sortProjects = projects => {
    const compare = function(a, b) {
      return b.updatedAt - (a.updatedAt || 0)
    }
    return projects.sort(compare)
  }

  projects = _ => {
    const { sortProjects, filterProjects, props: { projects } } = this
    return compose(sortProjects, filterProjects)(projects)
  }

  render() {
    const { state: { filter }, props: { changeProjectFromStartupAction, classes }, projects } = this
    if (this.props.projects.length <= 1) return null
    return (
      <div>
        <div>
          <input type='text' onChange={this.updateFilter} value={filter} placeholder='Search...' />
        </div>
        <table className={classes.projectsTable}>
          <thead>
            <tr>
              <th>Title</th>
              <th>Devices</th>
              <th>Date</th>
              <th />
            </tr>
          </thead>
        </table>
        <div className={classes.scrollTable}>
          <table className={classes.projectsTable}>
            <tbody>
              {
                projects().map(function(project, i) {
                  return (
                    <tr key={i}>
                      <td
                        onClick={changeProjectFromStartupAction.bind(null, project.id)}
                        className={classes.openProjectEnabled}
                      >
                        {project.title}
                      </td>
                      <td>{project.deviceCount}</td>
                      <td>{timeAgo(project.updatedAt)}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { changeProjectFromStartupAction })(injectSheet(style)(StartupProjectList))



// WEBPACK FOOTER //
// ./src/components/ApplicationSetupModal/StartupProjectList.js